import gql from 'graphql-tag';

export const SUBMIT_REVIEW_FEEDBACK = gql`
  mutation voteReview($reviewId: String!, $isHelpful: Boolean!) {
    store {
      voteReview(reviewId: $reviewId, isHelpFul: $isHelpful)
    }
  }
`;
